import uniqueId from 'lodash/uniqueId'

export const getUniqueId = (prefix = 'redend_me_') => uniqueId(prefix)

export const getRandomId = () =>
  `reden_me_${Math.random()
    .toString(36)
    .substring(7)}`
